import React from 'react'
import "./CsrBanner.css"
import "./ResponsiveCsrBanner.css"
const host = process.env.REACT_APP_API_SERVER;
const CsrBanner = (bannerData) => {
    return (
        <>

            <section className='csr-banner-section'>
                <div className=" align-items-center">
                    <div className="text-start">
                        <div className="banner-top-img-bg-rel">
                            <img src={bannerData?.bannerData?.catalogueImage ? `${host}${bannerData?.bannerData?.catalogueImage}` : ""} alt="" className='img-fluid banner-img-tag' />
                            {/* <div className="banner-top-content-absol business-heading text-start">
                                <img src="/images/help-and-support/heading-bg.png" alt="" className='img-fluid' />
                                <div className='business-banner-heading'>
                                    <div className="container">
                                        c
                                    </div>
                                </div>
                            </div> */}
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default CsrBanner